<div class="one-row">
    <span class="spacer"></span>
    <div class="one-row">
        <span class="spacer"></span>
        <button mat-icon-button color="accent" (click)="previousWeek()">
            <mat-icon>chevron_left</mat-icon>
        </button>
        <span class="kw-text" (click)="openCalenderWeekSelector()">KW {{ calendarWeek?.weekNumber }}</span>
        <span>{{ calendarWeek?.monday | date: "dd.MM.yyyy" }} - {{ calendarWeek?.sunday | date: "dd.MM.yyyy" }}</span>
        <button mat-icon-button color="accent" (click)="nextWeek()">
            <mat-icon>chevron_right</mat-icon>
        </button>
        <div *ngIf="currentKW.weekNumber !== calendarWeek?.weekNumber" style="width: 160px">
            <button mat-stroked-button color="accent" (click)="setCurrentWeek()"> aktuelle KW </button>
        </div>
        <span class="spacer"></span>
    </div>
    <span class="spacer"></span>
</div>
